<template>
    <div class="fst-Help">
        <div class="fst-modal-container"
             v-loading="loading"
             element-loading-text="Sending..."
             element-loading-spinner="el-icon-loading">
            <h3 class="mt-0 mb-1" v-html="$t('label.' + (msgType === 'error' ? 'describeError': 'describeIdea'))"></h3>
            <el-input type="textarea" class="mt-2"
                      :rows="6" v-model="text"
                      :placeholder="$t('label.writeMessagePlaceholder')"></el-input>

            <div class="inputBlock">
                <input type="file" ref="uploadFile"
                       multiple id="attachFile" class="inputfile"
                       @change="imageUploaded()">
                <el-tooltip :open-delay="500" placement="top" effect="light"
                            content="Максимум - 10 файлов, каждый файл не более 5 Мб">
                    <label for="attachFile"><i class="far fa-paperclip mr-1"></i> {{$t('label.attachScreen')}}</label>
                </el-tooltip>
                <ol class="attachedFiles" v-if="attachFiles.length">
                    <li v-for="(attach, key) in attachFiles" :key="key">
                        {{attach.fileName}}
                    </li>

                </ol>
            </div>
            <div class="mt-2">
                <el-checkbox v-model="allowsContact">{{$t('label.allowsContact')}}</el-checkbox>
            </div>
            <!--img class="resImage" :src="attachUrl" v-if="attachUrl"/ -->

            <div class="control">
                <el-button type="text" class="mt-2" @click="$emit('showUserFeedback')"
                           v-html="$t('cancel')"></el-button>
                <el-button type="primary" class="mt-2" @click="handleSendMessage()"
                           v-html="$t('sendMessage')"></el-button>
            </div>
        </div>


    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "UserFeedback",
        data() {
            return {
                text: '',
                loading: false,
                attachFiles: [],
                allowsContact: true,
                maxFileSize: 5000000,
            };
        },
        props: {
            msgType: String
        },
        computed: {
            ...mapState({
                userInfo: state => state.userInfo,
            })
        },
        mounted() {
        },
        methods: {
            sendIt(altEmail = '') {
                if (this.text) {
                    this.loading = true;
                    this.$services.userFeedback.submit({
                        type: this.msgType,
                        text: this.text,
                        allowsContact: this.allowsContact, // "согласие на общение"
                        contactEmail: altEmail || this.userInfo.email,
                        media: this.attachFiles.map(it => {
                            return {
                                "name": it.fileName,
                                "mime": "image/png",
                                "body": it.attachUrl
                            }

                        })

                    }).then(() => {
                        this.text = '';
                        this.loading = false;
                        this.$emit('showUserFeedback');
                    })
                }
            },
            handleSendMessage() {
                let _text = this.$t('feedbackForm.' + (this.msgType === 'bug' ? 'bugMessage' : 'suggestionMessage'))
                    + ` <a href="mailto:' + ${this.userInfo.email} + '">${this.userInfo.email}</a><br>`
                    + this.$t('feedbackForm.ifMailChange');
                if (this.allowsContact) {
                    this.$prompt(_text, this.$t('feedbackForm.thankYou'), {
                        confirmButtonText: this.$t('feedbackForm.change'),
                        customClass: 'w550px',
                        cancelButtonText: this.$t('feedbackForm.cancel'),
                        dangerouslyUseHTMLString: true,
                        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                        inputErrorMessage: 'Невалидный адрес E-mail'
                    }).then(({value}) => {
                        this.$message({
                            type: 'success',
                            message: 'Sent to email: ' + value
                        });
                        this.sendIt(value);
                    }).catch(() => {
                        this.sendIt();
                    });
                } else {
                    this.$message({
                        type: 'success',
                        message: 'Ваше сообщение отправлено'
                    });
                    this.sendIt();
                }
            },
            imageUploaded() {
                let self = this,
                    $file = document.querySelector('#attachFile[type=file]'),
                    files = (Array.from($file['files']).filter(it => it.type.includes('image/')) || []).slice(0, 10);
                this.attachFiles = []
                if (!files.length) {
                    $file.value = this.attachFiles = [];
                    this.$alert(this.$t('errors.onlyImages'), this.$t('warning'), {customClass: 'md'});
                }else if (files.some(it => it.size > self.maxFileSize)) {
                    $file.value = this.attachFiles = [];
                    this.$alert(this.$t('errors.maxImageSize', {size: Math.ceil(self.maxFileSize/1000000)}), this.$t('warning'), {customClass: 'md'});
                } else {
                    Object.keys(files).forEach(i => {
                        const file = files[i];
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            let base64String = reader.result.replace("data:", "")
                                .replace(/^.+,/, "");

                            // console.log('--- file in ---', file)
                            self.attachFiles.push({
                                attachUrl: 'data:image/png;base64, ' + base64String,
                                fileName: file.name.replace(/\.\w*$/, '.png')
                            })
                        }
                        reader.readAsDataURL(file);
                    })

                }
            },
            reset() {
                let file = document.querySelector('#attachFile[type=file]');
                this.text = '';
                file.value = '';
                this.attachFiles = [];
                // console.log('this.$refs.uploadFile', file)
            }
        }
    };
</script>

<style lang="scss" scoped>
    .fst-modal-container {
        max-height: none;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        min-height: 55vh;
    }

    .control {
        margin-top: auto;
        display: flex;
        gap: 7px;
        justify-content: flex-end;
        width: 100%;
    }

    .inputBlock {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        min-height: 38px;
        margin-top: 10px;
        width: 100%;

        label {
            white-space: nowrap;
        }

        .el-input {
            flex: 1;
        }
    }

    .attachedFiles {
        padding: 5px 10px;
        border: 1px solid #D7E1FC;
        border-radius: 4px;
        font-size: 0.825rem;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
        flex: 1;
        list-style-position: inside;

        li {
            max-width: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
</style>